import { render, staticRenderFns } from "./friendlist.vue?vue&type=template&id=2e1ab6ef&scoped=true&"
import script from "./friendlist.vue?vue&type=script&lang=js&"
export * from "./friendlist.vue?vue&type=script&lang=js&"
import style0 from "./friendlist.vue?vue&type=style&index=0&id=2e1ab6ef&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ab6ef",
  null
  
)

export default component.exports